<template>
  <div id="credit-card-payment">
    <loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="true"
             loader='bars'></loading>
  </div>
</template>

<script>
import VueLoading from "vue-loading-overlay";
import {paymentService} from "@/services/api/paymentService";
import {PaymentProviders} from "@/constants/constants";

export default {
  data() {
    return {
      externalUrl : "",
      isLoading: false
    }
  },
  props: {
    isTopup: {
      Type: Boolean
    }
  },
  components:{
    'loading' : VueLoading,

  },
  async mounted() {
    await this.loadAdyen();
  },
  methods: {
    async loadAdyen() {
      this.isLoading = true;
      const result = await paymentService.initPayment(PaymentProviders.ADYEN);
      if (result.errorCode < 0) {
        this.makeToast('danger', result.errorMsg);
        return;
      }

      this.externalUrl = result.redirectURL;
      this.openExternalUrl();

      this.isLoading = false;
    },
    openExternalUrl() {
      if (this.externalUrl) {
        window.open(this.externalUrl, '_self');
      }
    },
  },
};
</script>
